import { Skeleton, TableCell, TableRow } from '@ui/components';
import { cn } from '@ui/lib/utils';
import { CSSProperties } from 'react';

type AppTableSkeletonColumn = {
  id: string;
  width?: string | number;
};

type AppTableSkeletonProps = {
  columns: AppTableSkeletonColumn[];
  rowCount?: number;
  rowHeight?: number;
  rowClassName?: string;
  cellClassName?: string;
  getRowStyle?: (rowIndex: number) => CSSProperties | undefined;
};

export const AppTableSkeleton = ({
  columns,
  rowCount = 6,
  rowHeight,
  rowClassName,
  cellClassName,
  getRowStyle,
}: AppTableSkeletonProps) => {
  if (!columns.length || rowCount <= 0) {
    return null;
  }

  return (
    <>
      {Array.from({ length: rowCount }).map((_, rowIndex) => {
        const rowStyle: CSSProperties = {
          ...(rowHeight ? { height: rowHeight } : {}),
          ...(getRowStyle ? getRowStyle(rowIndex) : {}),
        };

        return (
          <TableRow
            key={`skeleton-row-${rowIndex}`}
            className={cn('hover:bg-inherit', rowClassName)}
            style={rowStyle}
          >
            {columns.map((column) => (
              <TableCell
                key={`${column.id}-${rowIndex}`}
                className={cn(
                  'overflow-hidden text-ellipsis whitespace-nowrap [&:not(:last-child)]:border-r',
                  cellClassName,
                )}
                style={column.width ? { width: column.width } : undefined}
              >
                <Skeleton className="h-4 w-full" />
              </TableCell>
            ))}
          </TableRow>
        );
      })}
    </>
  );
};
